import React from 'react';
import '../AntWidgetSkeleton/index.scss';
import './index.scss';

// Bề rộng tượng trưng — cố định để React không diff thừa.
var TAB_WIDTHS = [72, 96, 84, 68, 90, 78];
var COL_WIDTHS = [24, 20, 20, 18, 18, 16];

function times(n) {
    return Array.from({ length: Math.max(n | 0, 0) }, function (_, i) {
        return i;
    });
}

/**
 * Khung xám tượng trưng cho một màn phiếu (AntVoucher) trong lúc chờ máy chủ trả
 * dữ liệu lần đầu: khối đầu phiếu, dải thẻ, và một bảng dòng.
 *
 * Cố ý KHÔNG dựng lại đúng từng ô của phiếu thật — chỉ giữ đúng khối và chiều cao
 * để bố cục không xê dịch khi dữ liệu về.
 */
export default function AntVoucherSkeleton(props) {
    var showHeader = props.showHeader !== false;
    var headerRows = props.headerRows || 3;
    var headerCols = props.headerCols || 4;
    var tabCount = Math.min(Math.max(props.tabs || 4, 1), TAB_WIDTHS.length);
    var rows = props.rows || 6;
    var cols = Math.min(props.cols || 5, COL_WIDTHS.length);

    return (
        <div className="ant-voucher-skeleton" aria-hidden="true">
            {showHeader && (
                <div className="ant-voucher-skeleton__card">
                    {times(headerRows).map(function (r) {
                        return (
                            <div key={r} className="ant-voucher-skeleton__hrow">
                                {times(headerCols).map(function (c) {
                                    return (
                                        <div key={c} className="ant-voucher-skeleton__field">
                                            <span className="ant-sk ant-voucher-skeleton__label" />
                                            <span className="ant-sk ant-voucher-skeleton__input" />
                                        </div>
                                    );
                                })}
                            </div>
                        );
                    })}
                </div>
            )}

            <div className="ant-voucher-skeleton__tabstrip">
                {times(tabCount).map(function (i) {
                    return <span key={i} className="ant-sk ant-voucher-skeleton__tab" style={{ width: TAB_WIDTHS[i] }} />;
                })}
            </div>

            <div className="ant-voucher-skeleton__card ant-voucher-skeleton__grid">
                <div className="ant-voucher-skeleton__grow ant-voucher-skeleton__grow--head">
                    {times(cols).map(function (c) {
                        return <span key={c} className="ant-sk ant-voucher-skeleton__cell" style={{ width: COL_WIDTHS[c] + '%' }} />;
                    })}
                </div>
                {times(rows).map(function (r) {
                    return (
                        <div key={r} className="ant-voucher-skeleton__grow">
                            {times(cols).map(function (c) {
                                return <span key={c} className="ant-sk ant-voucher-skeleton__cell" style={{ width: COL_WIDTHS[c] + '%' }} />;
                            })}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
